<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="componentId" :key="componentId")
      button.button(slot="trigger" v-if="reservation !== null" ) Request preauth
      a.fa-stack.fa-lg(slot="trigger" v-else)
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      .row
        .column
          label Amount
            input(type="number", v-model="amount")
      ActionButton(slot="footer", :action="save") Save
      button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel

</template>

<script>
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import ActionButton from '../../components/structure/ui/ActionButton'
import ModalReveal from '../../components/structure/foundation/ModalReveal'
import MaggieHelper from "../../maggieHelper";
import {EventBus} from "../../eventBus";

export default {
  name: 'PreauthReveal',
  components: {ActionButton, ModalReveal},
  data() {
    return {
      amount: 0,
    }
  },
  created() {

  },
  methods: {
    save() {
      return KeplerBackofficeSdk.reservations.select(this.reservation.id).requestPreauth(this.amount, () => {
        MaggieHelper.notification('', 'preauth created')
        EventBus.$emit('reload-list')
        this.$refs[this.componentId].close()
      })
    }
  },
  computed: {
    componentId() {
      return `chargeReveal-${this._uid}`
    },
  },
  props: {
    reservation: {
      type: Object,
      default: null,
    }
  }
}
</script>



// WEBPACK FOOTER //
// PreauthReveal.vue?027c8536